<template>
    <div class="card tour-simple-card">
        <div class="badge-discount"
             v-if="specialOffer.label.length > 0">
            <span class="label" v-html="specialOffer.label"></span>
        </div>
        <img :src="specialOffer.image" class="card-img-top" :alt="specialOffer.title">
        <div class="card-body">
            <h4 class="card-title">{{ specialOffer.title }}</h4>
            <div v-html="specialOffer.description"></div>
            <div class="card-actions">
                <a class="btn btn-primary w-100">Book now (${{ specialOffer.price }})</a>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "SpecialOfferCard",
    props: {
        specialOffer: {
            type: Object,
            required: true
        }
    }
}
</script>

<style scoped>

</style>
